import { CopyLinkButton } from '@ui/kit';
import { copyWrapperCls, copyLabelCls } from './copy-link.styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CopyLink({
  href
}) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    jsxs("label", {
      className: copyWrapperCls,
      children: [/*#__PURE__*/jsx("div", {
        className: copyLabelCls,
        children: "Kopier link"
      }), /*#__PURE__*/jsx(CopyLinkButton, {
        href: href
      })]
    })
  );
}

export { CopyLink };
//# sourceMappingURL=copy-link.js.map
